import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

/**
 * Copy a link to the clipboard and say so — `label` names it, e.g. "Form
 * link". Where the browser refuses, the link stays on screen to copy by hand.
 */
export function useCopyLink() {
  const { enqueueSnackbar } = useSnackbar();
  return useCallback(async (url: string, label: string) => {
    try {
      await navigator.clipboard.writeText(url);
      enqueueSnackbar(`${label} copied`, { variant: 'success' });
    } catch {
      enqueueSnackbar(`${label}: ${url}`, { variant: 'info', persist: true });
    }
  }, [enqueueSnackbar]);
}
